import { DetailsSectionFlowContent } from 'app/main/components/page-layouts';
import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import OpportunitiesEvents from './OpportunitiesEvents';

import OpportunitiesDetailsSectionInfo from './details/sections/OpportunitiesDetailsSectionInfo';
import OpportunitiesDetailsSectionSecondaryInfo from './details/sections/OpportunitiesDetailsSectionSecondaryInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<OpportunitiesDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<OpportunitiesDetailsSectionSecondaryInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="oppo_descriptionhtml"
				value={props.model.oppo_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
			<InlineTitle text="DETAILS_FLOW_SECTION" />
			<DetailsSectionFlowContent module="opportunities" {...props} />
		</>
	),
	events: OpportunitiesEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
